import React from 'react'
import { Phone } from '../../../svgIcons/phone'
import { Data } from '../../../svgIcons/data'
import {Cloud} from '../../../svgIcons/cloud'
import { WiFi } from '../../../svgIcons/wifi'

export const MenuItems = [
  {
    nom: 'téléphonie',
    icon: <Phone />,
    submenu: [

      { nom: 'Téléphonie Fixe', url: '/telephonie-entreprise' },
      { nom: 'Téléphonie Mobile', url: '/flotte-mobile-entreprise' },
      { nom: 'Communications Unifiées', url: '/communications-unifiees' },
      { nom: 'Centre de Contact', url: '/centre-contact' }
    ]
  },
  {
    nom: 'réseau',
    icon: <Data />,
    submenu: [
      { nom: 'VPN MPLS', url: '/solution-vpn' },
      { nom: 'SD-WAN', url: '/sd-wan' },
      { nom: 'Firewall', url: '/firewall' }
    ]
  },
  {
    nom: 'internet',
    icon: <WiFi size={30} />,
    submenu: [
      { nom: 'SDSL', url: '/sdsl' },
      { nom: 'Fibre FTTH', url: '/fibre-ftth' },
      { nom: 'Fibre FTTO', url: '/fibre-ftto' },
      { nom: "4G/5G", url: "/reseau-4g/" }
    ]
  },
  {
    nom: 'cloud',
    icon: <Cloud />,
    submenu: [
      { nom: 'Hébergement', url: '/hebergement' }
    ]
  }
]
